module.exports = new __parcel__URL__("RenewableEnergyGermany.84bd93b9.png").toString();